/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SearchControl from 'app/components/common/SearchControl.jsx';
import classnames from 'classnames';
import DropdownButton from 'app/components/common/DropdownButton.jsx';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import { Breakpoint } from 'react-socks';

class SocialHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSearchOpen: false
        };

    }

    render() {
        var controlBarClass = classnames('control-bar', {
                'full' : (this.props.sortButton !== null) ? true : false,
                'social-modal-header' : (this.props.context === 'modal' || this.props.context === 'bulk-modal') ? true : false,
                'social-selection' : (this.props.context === 'input') ? true : false
            }),
            searchClass = classnames('control search social-config',
            {
                'in-modal' : (this.props.context === 'modal' || this.props.context === 'bulk-modal') ? true : false
            }),
            filterButton = null,
            serviceHeader = null,
            Icon = null;

        if (this.props.filterLabel !== '\u00a0') {
            filterButton = (
                <DropdownButton
                    label={this.props.filterLabel}
                    action={this.props.filterButtonCallback} />
            );
        } else if (this.props.showFilter === false) {
            filterButton = null;
        } else {
            filterButton = (
                <DropdownButton />
            );
        }

        return (
            <div>
                <Breakpoint desktop only>
                    <div className={controlBarClass}>
                        <div className="control-row">
                            {filterButton}
                            <div className={searchClass}>
                                <SearchControl
                                    {...this.props}
                                    reset={this.props.resetSearch}
                                    changeHandler={this.props.searchCallback}
                                    wrapperClass="header-control expandable"
                                    focusHandler={this.props.focusHandler}
                                    fieldIcon="icon ion-android-search"
                                    defaultFocus={false}
                                    expandable={true} />
                            </div>
                            {(this.props.sortButtonCallback !== null) ? (
                                <DropdownButton
                                    controlClass="icon-display"
                                    labelClass="icon-display"
                                    label={<i className="icon ion-android-funnel"/>}
                                    action={this.props.sortButtonCallback} />
                            ) : null}
                        </div>
                    </div>
                </Breakpoint>
                <Breakpoint mobile only>
                    <div className={controlBarClass.replace("control-bar", "mobile-control-bar")}>
                        {(this.props.context === 'modal' || this.props.context === 'bulk-modal' || this.props.context === '') ? (
                            <div className="control new social">
                                {this.props.actionButton}
                            </div>
                        ) : null}
                        <div className={searchClass}>
                            <SearchControl
                                {...this.props}
                                placeholder="Search"
                                reset={this.props.resetSearch}
                                changeHandler={this.props.searchCallback}
                                wrapperClass="header-control"
                                focusHandler={this.props.focusHandler}
                                defaultFocus={false}
                                fieldIcon="icon ion-search" />
                        </div>
                        <div className="control-row">
                            {filterButton}
                            {(this.props.sortButtonCallback !== null) ? (
                                <DropdownButton
                                    controlClass="sort solo"
                                    labelClass="sort"
                                    label={this.props.sortLabel}
                                    action={this.props.sortButtonCallback} />
                            ) : null}
                        </div>
                    </div>
                </Breakpoint>
                {this.props.filterDropdown}
                {this.props.sortDropdown}
            </div>
        );
    }

};

SocialHeader.propTypes = {
    filterButtonCallback: PropTypes.func,
    filterLabel: PropTypes.string,
    searchCallback: PropTypes.func,
    actionButton: PropTypes.element,
    filterDropdown: PropTypes.element,
    sortLabel: PropTypes.string,
    sortButtonCallback: PropTypes.func,
    sortDropdown: PropTypes.element,
    context: PropTypes.string,
    resetSearch: PropTypes.bool,
    focusHandler: PropTypes.func,
    showFilter: PropTypes.bool
};

SocialHeader.defaultProps = {
    filterButtonCallback: null,
    filterLabel: '',
    searchCallback: null,
    actionButton: null,
    filterDropdown: null,
    sortLabel: '',
    sortButtonCallback: null,
    sortDropdown: null,
    context: '',
    resetSearch: false,
    focusHandler: null,
    showFilter: true,
    serviceId: 0
};

export default SocialHeader;
